
import { VISITS_ENDPOINT_URL } from '../shared/config';
import {
  formatPhoneNumberWithoutPlusOne,
  updatePhoneNumberElements,
  updatePhoneNumberElementsHref,
} from '../d2c/utils';
import { lawftyVisits } from '../d2c/visits';
import { handleUnbounceFormSubmission } from './form';
import { createAndAppendIntercom, setupIntercomButtons } from './chatbot';

const visitsApi = lawftyVisits(VISITS_ENDPOINT_URL, { website: 'unbounce' });

const onLanding = async () => {
  const visitData = await visitsApi.getVisitData();

  createAndAppendIntercom({
    visitToken: visitData.visitToken,
    campaignId: visitData.campaignId,
    sourceId: visitData.sourceId,
    phoneNumber: formatPhoneNumberWithoutPlusOne(
      visitData.phoneNumber || localStorage.getItem('phoneNumber') || '',
    ),
    property: 'unbounce',
  });
  setupIntercomButtons();

  const phoneNumber = visitData.phoneNumber;
  const formattedPhoneNumber = formatPhoneNumberWithoutPlusOne(phoneNumber);

  updatePhoneNumberElements(phoneNumber, formattedPhoneNumber);
  updatePhoneNumberElementsHref(phoneNumber);

  const visitTokenField = document.getElementById('visitTokenField');
  if (visitTokenField) {
    (visitTokenField as HTMLInputElement).value = visitData.visitToken;
  }
};

document.addEventListener('DOMContentLoaded', async () => {
  await onLanding();

  const forms = document.querySelectorAll<HTMLFormElement>('.form-wrapper form');

  forms.forEach((form) => {
    // Clone the form without losing current input values
    const clonedForm = form.cloneNode(true) as HTMLFormElement;

    // Copy current values from the original form to the clone
    const originalInputs = Array.from(form.elements) as HTMLInputElement[];
    const clonedInputs = Array.from(clonedForm.elements) as HTMLInputElement[];

    originalInputs.forEach((input, i) => {
      if ('value' in input) {
        clonedInputs[i].value = input.value;
      }
      if (input.checked !== undefined) {
        clonedInputs[i].checked = input.checked;
      }
    });

    // Replace the old form with the clone
    form.replaceWith(clonedForm);

    // Remove 'action' attribute
    clonedForm.removeAttribute('action');

    // Attach submission handler
    handleUnbounceFormSubmission(clonedForm);

    // Reattach phone number formatting if needed
    const phoneInput = clonedForm.querySelector<HTMLInputElement>('#phone_number');
    if (phoneInput) {
      const DEFAULT_COUNTRY = 'US';
      const formatter = new libphonenumber.AsYouType(DEFAULT_COUNTRY);
      let lastFormattedValue = phoneInput.value;

      phoneInput.addEventListener('input', (event) => {
        const currentRawInputValue = (event.target as HTMLInputElement).value;
        const oldSelectionStart = phoneInput.selectionStart || 0;

        let newValueToFormat = currentRawInputValue;

        if (currentRawInputValue.length < lastFormattedValue.length) {
          const currentDigits = currentRawInputValue.replace(/\D/g, '');
          const lastDigits = lastFormattedValue.replace(/\D/g, '');
          if (currentDigits === lastDigits && currentDigits.length > 0) {
            newValueToFormat = currentDigits.slice(0, -1);
          }
        }

        if (newValueToFormat === '') {
          phoneInput.value = '';
          phoneInput.setCustomValidity('');
          phoneInput.setSelectionRange(0, 0);
          formatter.reset();
          lastFormattedValue = '';
          return;
        }

        formatter.reset();
        const newFormattedValue = formatter.input(newValueToFormat);
        phoneInput.value = newFormattedValue;
        lastFormattedValue = newFormattedValue;

        const digitsBeforeOldCursor = currentRawInputValue.substring(0, oldSelectionStart).replace(/\D/g, '').length;

        let newSelectionStart = newFormattedValue.length;
        let currentDigitsCount = 0;
        for (let i = 0; i < newFormattedValue.length; i++) {
          if (/\d/.test(newFormattedValue[i])) currentDigitsCount++;
          if (currentDigitsCount === digitsBeforeOldCursor) {
            newSelectionStart = i + 1;
            break;
          }
        }

        newSelectionStart = Math.min(newSelectionStart, newFormattedValue.length);
        phoneInput.setSelectionRange(newSelectionStart, newSelectionStart);

        if (!libphonenumber.isValidPhoneNumber(newFormattedValue, DEFAULT_COUNTRY)) {
          phoneInput.setCustomValidity('Invalid phone number');
        } else {
          phoneInput.setCustomValidity('');
        }
      });
    }
  });
});
